import { jsx as _jsx } from "react/jsx-runtime";
import { isValidElement, useMemo } from 'react';
import { App as AntdApp } from 'antd';
import { Icon } from '../icons/icon.js';
const STATUS_ICON = {
    success: _jsx(Icon, { name: "check", size: 20 }),
    info: _jsx(Icon, { name: "info", size: 20 }),
    warning: _jsx(Icon, { name: "warning", size: 20 }),
    error: _jsx(Icon, { name: "close", size: 20 }),
};
function statusIcon(type) {
    return type && type !== 'loading' ? STATUS_ICON[type] : undefined;
}
/** AntD's own test for "this is an options object, not the content itself". */
function isMessageArgs(content) {
    return (typeof content === 'object' &&
        content !== null &&
        !isValidElement(content) &&
        !Array.isArray(content) &&
        'content' in content);
}
export function withMessageIcons(message) {
    const typed = (type) => (content, duration, onClose) => {
        const args = isMessageArgs(content) ? content : { content };
        return message[type]({ ...args, icon: args.icon ?? STATUS_ICON[type] }, duration, onClose);
    };
    return {
        ...message,
        open: (args) => message.open({ ...args, icon: args.icon ?? statusIcon(args.type) }),
        success: typed('success'),
        info: typed('info'),
        warning: typed('warning'),
        error: typed('error'),
    };
}
export function withNotificationIcons(notification) {
    const typed = (type) => (args) => notification[type]({ ...args, icon: args.icon ?? STATUS_ICON[type] });
    return {
        ...notification,
        open: (args) => notification.open({ ...args, icon: args.icon ?? statusIcon(args.type) }),
        success: typed('success'),
        info: typed('info'),
        warning: typed('warning'),
        error: typed('error'),
    };
}
function useApp() {
    const app = AntdApp.useApp();
    // AntD memoises the context value, so these are stable across renders and
    // `useEffect`s keyed on them (the feedback bridge) do not re-run.
    return useMemo(() => ({
        ...app,
        message: withMessageIcons(app.message),
        notification: withNotificationIcons(app.notification),
    }), [app]);
}
function App(props) {
    return _jsx(AntdApp, { ...props });
}
const KitApp = Object.assign(App, {
    useApp,
});
export { KitApp as App };
//# sourceMappingURL=app.js.map